import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';

import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';



        
const departmentalCertificate = ({ result }) => (
  
              <View size="A4" style={style.page}> 
               <Text style={[style.title, style.ArialBlack]}>SERVICE CERTIFICATE</Text>
        
               <Text style={[style.paragraph, { marginTop: 10 }]}>Name of the college: <Text style={style.ArialBold}>{result.institutionName}</Text>  </Text>
               
                <Text style={[style.paragraph, { marginTop: 10 }]}>
{result.employeeName} rendered  his/ her service in the {result.institutionName} from {result.dateOfAppointment} to {result.dateOfRetirement}  in the capacity of a full time servant only.

                </Text>

                      
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>

              
        <View style={[style.solidLine,{marginTop: 100}]} />
           </View>

);

export default departmentalCertificate;